import { CSSProperties } from "react"
import { TextProps } from "../../types/props"

const getTextShadowValues = (shadow: string|undefined) => {
  if (!shadow) return {
    x: 0,
    y: 0,
    blur: 0,
    color: 'rgba(0,0,0,1)'
  }

  let items = shadow.split(' ')

  return {
    x: parseInt(items[0]),
    y: parseInt(items[1]),
    blur: parseInt(items[2]),
    color: items[3]
  }
}

export const getTextOutline = (textProps:TextProps) => {
    if(!textProps) return;
		let styles: CSSProperties = {}
		const padding = textProps.style?.padding ? parseInt(`${textProps.style?.padding}`) : 0
		const bottomPadding = textProps.style?.paddingBottom ? parseInt(`${textProps.style?.paddingBottom}`) : 0
		// desired_padding prevents text shadow from being cut off at the bottom
		let desired_padding = 0
		let shadows = []

		if(textProps.outline && textProps.outline.width > 0) {
			const color = textProps.outline.color
			const width = textProps.outline.width
			desired_padding = width + 2

			for(let i = -width; i <= width; i++) {
				for(let j = -width; j <= width; j++) {
					shadows.push(`${i*1}px ${j*1}px 0 ${color}`)
				}
			}
		}

		// Add textShadow to the list of the element has one already
		if (textProps.style?.textShadow) {
			shadows.push(textProps.style.textShadow)

			const shadow = getTextShadowValues(textProps.style?.textShadow)

			if (shadow.y && desired_padding < (shadow.y + 2)) {
				desired_padding = shadow.y + 2
			}
		}

		if (padding < desired_padding || bottomPadding < desired_padding) {
			styles['paddingBottom'] = `${desired_padding}px`
		}

		styles['textShadow'] = shadows.join(',')

		return styles
	}